export default {
  ['ACTIONS_QUEUE_SHIFTED']: 'ACTIONS_QUEUE_SHIFTED',
};



// WEBPACK FOOTER //
// ./src/modules/actionsQueue/types.js